// src/containers/TermsnConditions/AddTermsnCondition.jsx

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from "../../../components/ui/dialog";
import { Formik } from "formik";
import { Button } from "../../../components/ui/button";
import { FormikInput, FormikSearchSelect, FormikTextArea } from "../../../components/formik-components";
import * as yup from "yup";
import { TermsnConditionTypeEnum } from "../../../constants/appConstant";
import Common from "../../../helper/common";
import { Textarea } from "../../../components/ui/textarea";

const validationSchema = yup.object({
  type: yup.string().required("Type is required"),
  condition: yup.string().required("Condition is required"),
});

const initialValues = {
  id: null,
  type: "",
  condition: "",
};

const AddTermsnCondition = ({ id, open, setOpen, onClose, selectedItem }) => {
    const allTypes = Common.Utility.enumToArray(TermsnConditionTypeEnum);

    const initialValues = {
        id: selectedItem?.id ?? null,
        //type: selectedItem?.type ?? "",
        type: allTypes.find((opt) => opt.name === selectedItem?.type)?.id ?? "",
        condition: selectedItem?.condition ?? "",
    };

    const handleSubmit = async (values, actions) => {
        const payload = { ...values, id };

        const response = await Common.ApiService.getInstance().request(
            "AddUpdateTermsnConditions",
            payload,
            "POST"
        );

        actions.setSubmitting(false);

        if (response?.status === 1) {
            onClose();
            setOpen(false);
            Common.Utility.showToast("Saved successfully", "success");
        } else {
            Common.Utility.showToast(response?.message || "Failed to save", "error");
        }
    };

  return (
    <Dialog open={open} onOpenChange={setOpen} >
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>{id ? "Edit" : "Add"} Term & Condition</DialogTitle>
        </DialogHeader>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={handleSubmit}
        >
          {(formikProps) => (
            <>
              <div className="space-y-4 mt-4">
                <FormikSearchSelect
                  formikProps={formikProps}
                  name="type"
                  label="Type"
                  placeholder="Select Type"
                  data={Common.Utility.enumToArray(TermsnConditionTypeEnum)}
                />
                <FormikTextArea
                  formikProps={formikProps}
                  name="condition"
                  label="Condition"
                  placeholder="Enter condition"
                  rows={8}
                />
              </div>
              <DialogFooter className="mt-6">
                <DialogClose asChild>
                  <Button variant="outline">Cancel</Button>
                </DialogClose>
                <Button
                  type="button"
                  onClick={formikProps.handleSubmit}
                  disabled={formikProps.isSubmitting}
                >
                  {formikProps.isSubmitting ? "Saving..." : id ? "Update" : "Add"}
                </Button>
              </DialogFooter>
            </>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default AddTermsnCondition;
